var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11459",
    "data-name": "Group 11459",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.743,
    height: 19.747,
    viewBox: "0 0 19.743 19.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4158",
    "data-name": "Rectangle 4158",
    width: 19.743,
    height: 19.747,
    fill: "#484848"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11458",
    "data-name": "Group 11458",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M10.054,0A9.874,9.874,0,1,1,.005,9.524,9.856,9.856,0,0,1,10.054,0m8.285,9.867a8.464,8.464,0,1,0-8.394,8.466,8.445,8.445,0,0,0,8.394-8.466",
    transform: "translate(0 -0.001)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M156.1,147.529c0-.778,0-1.557,0-2.335a1.148,1.148,0,0,1,.046-.313.674.674,0,0,1,.729-.476.683.683,0,0,1,.6.612c.011.131.019.263.019.395q0,2.242,0,4.483a1.118,1.118,0,0,1-.062.365.668.668,0,0,1-.724.435.683.683,0,0,1-.584-.612c-.012-.127-.02-.255-.02-.383,0-.723,0-1.447,0-2.17",
    transform: "translate(-146.925 -135.912)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M157.49,85.425c-.01.145-.012.288-.03.429a.682.682,0,0,1-.692.6.673.673,0,0,1-.658-.618,5.615,5.615,0,0,1-.019-.735.7.7,0,0,1,.535-.695.684.684,0,0,1,.832.564c.017.153.021.306.031.458",
    transform: "translate(-146.911 -79.422)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.49dc06351ac087082121db07a2c6377b.svg";
export { ForwardRef as ReactComponent };